import { useState } from 'react'
import { Modal, Text, Group, Stack } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/Button'
import type { ManagedFaculty } from '../types'

interface Props {
  faculty: ManagedFaculty | null
  onClose: () => void
  onConfirm: () => Promise<void>
}

export function RemoveFacultyModal({ faculty, onClose, onConfirm }: Props) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const opened = faculty !== null

  const handleConfirm = async () => {
    setLoading(true)
    try {
      await onConfirm()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('remove_faculty_modal.title')}
      size='sm'
      centered
    >
      <Stack spacing='sm'>
        <Text size='sm'>
          {t('remove_faculty_modal.message', {
            name: faculty ? `${faculty.firstName} ${faculty.lastName}` : '',
          })}
        </Text>

        <Group position='right' mt='md'>
          <Button variant='default' onClick={onClose}>
            {t('remove_faculty_modal.cancel')}
          </Button>
          <Button
            color='red'
            onClick={handleConfirm}
            loading={loading}
          >
            {t('remove_faculty_modal.confirm')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
